import React from 'react';
import { Settings } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-pastel-100 py-10 px-4 text-center text-sm" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <div className="mb-6 flex justify-center" data-id="element-51">
          <a href="mailto:ebookdreamshop@gmail.com" className="inline-flex items-center gap-2 px-5 py-3 bg-navy-800 hover:bg-navy-700 border border-navy-700 text-white font-semibold rounded-xl transition-all transform hover:-translate-y-0.5 shadow-md" data-id="element-52">
            <Settings size={18} data-id="element-53" />
            <span data-id="element-54">Soporte: ebookdreamshop@gmail.com</span>
          </a>
        </div>
        <p className="mb-3" data-id="element-55">
          © {new Date().getFullYear()} EbookPoint Shop. Todos los derechos
          reservados.
        </p>
        <p className="text-xs opacity-60 max-w-2xl mx-auto" data-id="element-56">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}